var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPasswordView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_1862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30286 0.791016C4.17252 0.885102 3.08704 1.27576 2.15598 1.92356C1.22492 2.57135 0.481278 3.45333 0.00012207 4.48046C0.481278 5.50759 1.22492 6.38963 2.15598 7.03742C3.08704 7.68522 4.17252 8.07588 5.30286 8.16996C6.51236 8.15731 7.69384 7.80462 8.71237 7.15219C9.7309 6.49976 10.5454 5.57387 11.0626 4.48046C10.5454 3.38705 9.7309 2.46122 8.71237 1.80879C7.69384 1.15636 6.51236 0.803671 5.30286 0.791016ZM5.53146 2.50004C6.05667 2.5002 6.56034 2.70889 6.93172 3.08027C7.30309 3.45164 7.51184 3.95526 7.512 4.48046C7.51184 5.00566 7.30309 5.50934 6.93172 5.88071C6.56034 6.25209 6.05667 6.46078 5.53146 6.46094C5.00626 6.46078 4.5027 6.25209 4.13133 5.88071C3.75995 5.50934 3.55121 5.00566 3.55104 4.48046C3.55121 3.95526 3.75995 3.45164 4.13133 3.08027C4.5027 2.70889 5.00626 2.5002 5.53146 2.50004Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_1862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0625,
    height: 8.96094,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordView);
export default __webpack_public_path__ + "static/media/icon_password_view.4b9c7fc851b7d98fbe39021db55caa9a.svg";
export { ForwardRef as ReactComponent };